import { lazy } from "react"

export const YearsPage = lazy(() => import("./YearsPage"))